import React, {forwardRef} from 'react'
import tw from 'tailwind-styled-components'
import {DivWithHint} from '@components/common/hint/hint'
import {cn} from '@containers/html-utils'
import {getRightUrl} from '../../../../extensions/web-platform/get-right-url'
import {colorTextClass} from '../design-system'
import {IconProps, TwProps} from './types'

export type {IconProps}

export const getSize = (size: IconProps['size']): string => {
  return size ? `w-${size} h-${size}` : ''
}

const TwIcon = tw(DivWithHint)<TwProps>`
  flex
  items-center
  justify-center
  select-none
  ${p => cn(colorTextClass(p.$color), getSize(p.$size))}
`

export const IconSvg = forwardRef<HTMLDivElement, IconProps>(
  ({color, size, src, title, hint, className, style, onClick}, ref) => {
    if (!src) {
      return null
    }

    const rightSrc = getRightUrl(src)

    return (
      <TwIcon
        ref={ref}
        $size={size ?? 16}
        $color={color ?? 'grey'}
        // `span` instead of `div` to allow using inside other inline elems w/o warnings
        componentTag="span"
        title={title}
        content={hint}
        className={className}
        style={style}
        onClick={onClick}
      >
        <img src={rightSrc} />
      </TwIcon>
    )
  }
)
